import React from "react";
import authentication from "../authentication";
import { Redirect, Route } from "react-router-dom";

// https://tylermcginnis.com/react-router-protected-routes-authentication/

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
            authentication.getUsername() ? (
                <Component {...props} />
            ) : (
                <Redirect to={{ pathname: "./login", state: { from: props.location } }} />
            )
        }
    />
);

export default PrivateRoute;
